/**
 * Input — 表单输入（API Key、搜索、密码等）
 */

import { InputHTMLAttributes, forwardRef } from 'react';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ error = false, className = '', ...props }, ref) => {
    return (
      <input
        ref={ref}
        className={`w-full rounded-md border bg-white dark:bg-warm-dark px-3 py-2 text-base text-charcoal dark:text-charcoal-light placeholder:text-charcoal/40 focus:outline-none focus:ring-2 transition-colors ${
          error
            ? 'border-error focus:ring-error'
            : 'border-border-warm dark:border-border-warm-dark focus:ring-oasis focus:border-oasis'
        } ${className}`}
        {...props}
      />
    );
  }
);

Input.displayName = 'Input';
